<template>
  <div class="layer" :style="style" @click="handleClick">
    <component
      :layer="layer"
      :is="layer.component"
    />
  </div>
</template>
<script>
export default {
  name: 'ICLayer',
  inject: ['mode'],
  props: {
    layer: {
      type: Object,
      require: true
    }
  },
  methods: {
    handleClick (event) {
      this.$EventBus.$emit('setActive', this.layer)
      event.stopPropagation()
    }
  },
  computed: {
    style () {
      if (this.mode === 'screen') {
        const { size: { width, height } } = this.layer
        return {
          width: width + 'px',
          height: height + 'px',
        }
      }
      return {
        width: '100%',
      }
    }
  }
}
</script>

<style lang="less">
.layer {
  width: 100%;
  height: 100%;
  border: 1px solid #E9ECF0;
  background-color: #ffffff;
}
</style>
